"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var PageStatus = exports.PageStatus = /*#__PURE__*/function (PageStatus) {
  PageStatus["INITIAL_BG"] = "INITIAL_BG";
  PageStatus["SUCCESSFUL"] = "SUCCESSFUL";
  PageStatus["SUCCESSFUL_BG"] = "SUCCESSFUL_BG";
  PageStatus["ERROR"] = "ERROR";
  PageStatus["ERROR_BG"] = "ERROR_BG";
  PageStatus["LOCKED"] = "LOCKED";
  return PageStatus;
}({});
var LoggedInMeterReadingStatus = function LoggedInMeterReadingStatus(props) {
  var status = props.status;
  var pathDescriptions = ['M5 16.5C5 22.841 10.159 28 16.5 28S28 22.841 28 16.5 22.841 5 16.5 5 5 10.159 5 16.5z', 'M16.5 15.793l-4.243-4.243-.707.707 4.243 4.243-4.243 ' + '4.243.707.707 4.243-4.243 4.243 4.243.707-.707-4.243-4.243 ' + '4.243-4.243-.707-.707-4.243 4.243z', 'M16.298 21.941h1.408v1.412h-1.408V21.94zm1.126-1.412h-.848l-.282-5.647v-4.235h1.412v4.235l-.282 5.647z', 'M17 29c-6.617 0-12-5.383-12-12S10.383 5 17 5s12 5.383 12 ' + '12-5.383 12-12 12zm0-22C11.486 7 7 11.486 7 17s4.486 10 10 ' + '10 10-4.486 10-10S22.514 7 17 7z', 'M14 2.41L12.59 1 7 6.59 1.41 1 0 2.41 5.59 8 0 13.59 1.41 15 7 9.41 12.59 15 14 13.59 8.41 8z', 'M5 16.5C5 22.841 10.159 28 16.5 28S28 22.841 28 16.5 22.841 5 16.5 5 5 10.159 5 16.5z', 'M11.473,6.196 L8.562,8.392 L5.596,6.196 C4.789,5.587 ' + '4.306,4.62 4.306,3.609 L4.306,0.971 L12.763,0.971 ' + 'L12.763,3.609 C12.763,4.62 12.281,5.587 11.473,6.196 ' + 'L11.473,6.196 Z M11.473,11.805 C12.281,12.414 12.763,13.38 ' + '12.763,14.392 L12.763,17.029 L4.306,17.029 L4.306,14.392 ' + 'C4.306,13.38 4.789,12.414 5.596,11.805 L8.535,9.588 ' + 'L11.473,11.805 Z M8.49963909,11.358572 L10.2781868,12.8523834 ' + 'C10.7300419,13.2318662 11,13.8348579 11,14.4651852 L11,16 L6,16 ' + 'L6,14.4651852 C6,13.8348579 6.26995813,13.2318662 ' + '6.72181319,12.8523834 L8.49963909,11.358572 Z M13.734,3.609 ' + 'L13.734,0.971 L15.069,0.971 L15.069,0 L2,0 L2,0.971 L3.336,0.971 ' + 'L3.336,3.609 C3.336,4.923 3.962,6.179 5.012,6.971 L7.701,9 ' + 'L5.012,11.029 C3.962,11.821 3.336,13.078 3.336,14.392 ' + 'L3.336,17.029 L2,17.029 L2,18 L15.069,18 L15.069,17.029 ' + 'L13.734,17.029 L13.734,14.392 C13.734,13.078 13.107,11.821 ' + '12.058,11.029 L9.368,9 L12.058,6.971 C13.107,6.179 ' + '13.734,4.923 13.734,3.609 L13.734,3.609 Z'];
  if (status === PageStatus.INITIAL_BG) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "loggedinStatusIcon loggedinStatusIconInitialBg",
      xmlns: "http://www.w3.org/2000/svg",
      width: "33",
      height: "33",
      viewBox: "0 0 33 33"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "16.5",
      cy: "16.5",
      r: "16.5",
      fill: "#FFF"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M5 5h24v24H5z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: "loggedin-meterreading-pending-status-icon",
      d: pathDescriptions[0]
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: "#FFF",
      d: pathDescriptions[1]
    })));
  }
  if (status === PageStatus.ERROR_BG) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "loggedinStatusIcon loggedinStatusIconErrorBg",
      xmlns: "http://www.w3.org/2000/svg",
      width: "33",
      height: "33",
      viewBox: "0 0 33 33"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "16.5",
      cy: "16.5",
      r: "16.5",
      fill: "#FFF"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M5 5h24v24H5z"
    }), /*#__PURE__*/_react.default.createElement("g", {
      fill: "#F3463F"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: pathDescriptions[2]
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: pathDescriptions[3]
    }))));
  }
  if (status === PageStatus.ERROR) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "loggedinStatusIconError",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: "#F3463F",
      d: pathDescriptions[4]
    })));
  }
  if (status === PageStatus.SUCCESSFUL_BG) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "loggedinStatusIcon loggedinStatusIconSuccesfulBg",
      xmlns: "http://www.w3.org/2000/svg",
      width: "33",
      height: "33",
      viewBox: "0 0 33 33"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "16.5",
      cy: "16.5",
      r: "16.5",
      fill: "#FFF"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M5 5h24v24H5z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: "#39CB2C",
      d: pathDescriptions[5]
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: "#FFF",
      d: "M14.834 22L9 15.813l.89-.94 4.946 5.246L22.512 12l.888.94L14.834 22"
    })));
  }
  if (status === PageStatus.SUCCESSFUL) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "loggedinStatusIconSuccessful",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: "#39CB2C",
      d: "M1.432 7.687L0 9.149 5.727 15 18 2.463 16.568 1 5.728 12.075z"
    })));
  }
  if (status === PageStatus.LOCKED) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "18",
      viewBox: "0 0 14 18"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("polygon", {
      id: "hourglass-a",
      points: "18 0 0 0 0 18 18 18 18 0"
    })), /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(-2)"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fill: "#767676",
      d: pathDescriptions[6]
    })));
  }
  return null;
};
var _default = exports.default = LoggedInMeterReadingStatus;